import {QueryClient, QueryKey} from 'react-query';

interface IPaginatedMemberResponse {
  results?: Array<{id?: string}>;
  totalResults?: number;
  totalPages?: number;
  limit?: number;
  [key: string]: any;
}

export const removeMemberFromPaginatedCache = (
  queryClient: QueryClient,
  queryKey: QueryKey,
  memberId: string,
) => {
  queryClient.setQueryData<IPaginatedMemberResponse | undefined>(
    queryKey,
    (currentData: IPaginatedMemberResponse | undefined) => {
      if (!currentData?.results) {
        return currentData;
      }

      const nextResults = currentData.results.filter(
        (member) => member.id !== memberId,
      );
      const removedCount = currentData.results.length - nextResults.length;

      if (removedCount === 0) {
        return currentData;
      }

      const totalResults = Math.max(
        Number(currentData.totalResults || 0) - removedCount,
        0,
      );
      const limit = Number(currentData.limit || 0);

      return {
        ...currentData,
        results: nextResults,
        totalResults,
        totalPages: limit
          ? Math.max(Math.ceil(totalResults / limit), 1)
          : currentData.totalPages,
      };
    },
  );
};
